import React from "react"

import {
	Chip,
	IconButton,
	Stack,
	Tooltip,
} from "@mui/material"
import {
	DeleteOutline,
	Download,
	Link,
} from "@mui/icons-material"
import {
	GridColDef,
	GridValueGetterParams,
} from "@mui/x-data-grid"
import { GridRenderCellParams } from "@mui/x-data-grid/models/params/gridCellParams"

import { t } from "@lingui/macro"
import { DateTime } from "luxon"

import { getChipProps } from "components/commons/documents-chip-props"
import { AuthenticatedDownload } from "@sinossi/mates-react-library"
import { StorageEntries } from "services/storage-entries"


export interface DocumentTableInterface
{
	deleteDocument: (documentId: string) => void
	onDownloadError: (error: any, originalResponse: Response) => void
	getDownloadBaseUrl: () => string
	copyDocumentLink: (documentId: string) => void

	sessionAccountType: () => string
}


const defaultColumnDefinition: GridColDef = {
	field: "",
	headerName: "",
	headerAlign: "left",
	align: "left",
}
const getDocumentsTableColumns = (component: DocumentTableInterface): GridColDef[] => {
	const userIsBrand = component.sessionAccountType() === "BRAND"

	return [
		{
			...defaultColumnDefinition,
			field: "documentNumber",
			headerName: t({
				id: "dtc-number",
				message: "Numero documento",
			}),
			flex: 1.5,
			sortable: false
		},
		{
			...defaultColumnDefinition,
			field: "name",
			headerName: t({
				id: "dtc-name",
				message: "Nome documento"
			}),
			flex: 2.5,
			sortable: false
		},
		{
			...defaultColumnDefinition,
			field: "uploadDate",
			headerName: t({
				id: "dtc-date",
				message: "Data di caricamento",
			}),
			flex: 1.5,
			sortable: false,
			valueGetter: (params: GridValueGetterParams) => {
				return DateTime.fromISO(params.row.uploadDate).toFormat("dd/MM/yyyy HH:mm:ss")
			},
		},
		{
			...defaultColumnDefinition,
			field: "documentType",
			headerName: t({
				id: "dtc-type",
				message: "Tipo documento"
			}),
			flex: 1,
			renderCell: (params: GridRenderCellParams) => {
				return <Chip {...getChipProps(params.row.documentType)} />
			},
			sortable: false,
		},
		{
			...defaultColumnDefinition,
			field: "buttons",
			flex: 1,
			sortable: false,
			renderCell: (params: GridRenderCellParams) => (
				<Stack direction="row" alignItems="center" spacing={2}>
					{
						!userIsBrand &&
						<Tooltip title={"Elimina"} placement="top" arrow>
							<IconButton onClick={() => component.deleteDocument(params.row.id)}>
								<DeleteOutline sx={{ fontSize: 24, color: "#60666f" }} />
							</IconButton>
						</Tooltip>
					}
					<Tooltip title={"Copia link"} placement="top" arrow>
						<IconButton onClick={() => component.copyDocumentLink(params.row.id)}>
							<Link sx={{ fontSize: 24, color: "#60666f" }} />
						</IconButton>
					</Tooltip>
					<AuthenticatedDownload
						url={`${component.getDownloadBaseUrl()}/${params.row.id}`}
						filename={params.row.name}
						onDownloadError={component.onDownloadError}
						internalLoadingEnabled={false}>
						<IconButton>
							<Download sx={{ fontSize: 24, color: "#60666f" }} />
						</IconButton>
					</AuthenticatedDownload>
				</Stack>
			),
		},
	]
}

export default getDocumentsTableColumns
